export default {
    "EXPLORE": "البحث",
    "SHOP NOW": "تسوّق الآن!",
    "BOOK NOW": "احجز الآن!",
    "VIEW MORE": "لرؤية المزيد",
    "ORDER ON WHATSAPP": "اطلب الآن عبر الواتساب",
    "Phone": "للإتصال",
    "WhatsApp": "WhatsApp",
    "Instagram": "Instagram",
    "Snapchat": "Snapchat",
    "Twitter": "Twitter",
    "Youtube": "Youtube",
    "CHECKOUT OUR INSTAGRAM": "لزيارة صفحتنا على الانستغرام",
    "Powered by": "تم التشغيل بواسطة",
    "Get yours now!": "احصل على موقعك الآن!",
    "This site is Powered by Optimize App": "تم إنشاء هذا الموقع باستخدام عبر OptimizeApp",
    "بو نبيل": "بو نبيل",
    "SHOP ON INSTAGRAM": "تسوّق عبر الانستغرام",
    "ORDER ON INSTAGRAM": "اطلب عبر الانستغرام",
    "FOR INQUIRIES & ORDERS": "للطلب والاستفسار",
    "FOR RESERVATIONS & ORDERS": "للحجز والاستفسار",
    "CHECK OUT ON YOUTUBE": "للمزيد على اليوتيوب",
    "CHECK OUT ON INSTAGRAM": "للمزيد على الانستغرام",
    "CHECK OUT ON SNAPCHAT": "للمزيد على سناب شات"
}


// WEBPACK FOOTER //
// ./src/store/data/arabicStrings.js